// 261023 E3-P3j2b-2 (D8) — hook gọi «Để máy sửa N tập» / «Dừng». Dùng chung cho dải (NewStoryRunBar), đáy cột trái và trang tập. Logic quyết định ở `autoRepairView.ts` (thuần, có jest).
// Bấm hai lần không mở hai job: (1) cờ đang-gửi chặn trong cùng tick; (2) `requestId` sinh ở client và GIỮ NGUYÊN tới khi có kết quả chắc chắn (BE idempotent theo `requestId`: lần gửi lại trả đúng job cũ, `replay:true`).
import { useCallback, useRef, useState } from 'react';
import { message } from 'antd';
import { adaptationApi } from '../../../services/api/adaptation';
import { autoRepairErrorView, newRequestSlot, settleRequest, takeRequestId } from './autoRepairView';
import { genRequestId } from './newStoryBudgetView';
import { useWorkbenchCtx } from './WorkbenchContext';

export const useAutoRepair = (): { start: (episodes?: number[]) => Promise<void>; stop: () => Promise<void>; starting: boolean; stopping: boolean } => {
  const { storyId, refreshAll } = useWorkbenchCtx();
  const slot = useRef(newRequestSlot());
  const startBusy = useRef(false);
  const stopBusy = useRef(false);
  const [starting, setStarting] = useState(false);
  const [stopping, setStopping] = useState(false);

  const start = useCallback(async (episodes?: number[]) => {
    if (startBusy.current) return;
    startBusy.current = true; setStarting(true);
    try {
      const only = episodes && episodes.length > 0 ? [...episodes].sort((a, b) => a - b) : null;
      const requestId = takeRequestId(slot.current, only ? `ep:${only.join(',')}` : 'all', genRequestId);
      const r = await adaptationApi.autoRepairStart({ storyId, requestId, ...(only ? { episodes: only } : {}) });
      settleRequest(slot.current);
      message.success(r.replay ? 'Máy đang sửa — lệnh trước đó đã được nhận' : 'Máy bắt đầu sửa — chạy ở nền, bạn có thể làm việc khác', 6);
      await refreshAll();
    } catch (e) {
      const v = autoRepairErrorView(e);
      if (v.settled) settleRequest(slot.current);
      message.warning(v.text, 8);
      if (v.reload) await refreshAll();
    } finally { startBusy.current = false; setStarting(false); }
  }, [storyId, refreshAll]);

  const stop = useCallback(async () => {
    if (stopBusy.current) return;
    stopBusy.current = true; setStopping(true);
    try {
      await adaptationApi.autoRepairStop(storyId);
      message.info('Đã gửi lệnh dừng — máy dừng trước lời gọi kế, bản đang lưu giữ nguyên', 6);
      await refreshAll();
    } catch (e) {
      const v = autoRepairErrorView(e);
      message.warning(v.text, 8);
      if (v.reload) await refreshAll();
    } finally { stopBusy.current = false; setStopping(false); }
  }, [storyId, refreshAll]);

  return { start, stop, starting, stopping };
};
